import {Component, OnInit, Injector} from "@angular/core";
import {LoginComponent} from "@mango/authentication";
import {MatDialog} from "@angular/material/dialog";
import {ForgotPasswordDialogComponent} from "./forgot-password/forgot-password-dialog.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class AppLoginComponent extends LoginComponent implements OnInit {

  randomNumber: number;
  forgotPasswordEmail: string;

  backgroundPictureCount: number = 8;

  constructor(injector: Injector, public dialog: MatDialog) {
    super(injector);

    this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1;
  }

  getRandomBackground(): string {
    return `assets/login-photos/${this.randomNumber}.jpg`;
  }

  openForgotPasswordDialog() {
    this.dialog.open(ForgotPasswordDialogComponent);
  }
}
